import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ElectricalSidebar from './ElectricalSidebar';
import sp1 from '../../img/synchronization panel/sp1.jpg';
import sp2 from '../../img/synchronization panel/sp2.jpg'

function SynchronizingPanel() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 bg-light mt-5" id="synchronizing-panel">
      <div className="container">
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-9 col-md-8 mb-4">
            {/* Title */}
            <div className="text-center mb-4" data-aos="fade-up">
              <h2 className="fw-bold">🔄 Synchronization Panel</h2>
              <p className="text-muted">
                Reliable multi-generator or grid synchronization for uninterrupted power control.
              </p>
              <p className="text-muted fw-semibold">Synchronization PANEL &nbsp; | &nbsp; Electric Low Voltage Panel</p>
            </div>

            {/* Application */}
            <div className="mb-4" data-aos="fade-up">
              <p className="text-muted lead">
                Synchronization panels are used to synchronize multiple generators or a generator with the grid, ensuring stable power output and load sharing. Commonly used in industrial plants, commercial complexes, hospitals, and power stations where continuous and balanced power supply is critical.
              </p>
            </div>

            {/* Images */}
            <div className="row mb-4" data-aos="zoom-in">
              <div className="col-md-6 mb-3">
                <img
                  src={sp1}
                  alt="Synchronization Panel"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6 mb-3">
                <img
                  src={sp2}
                  alt="Synchronizing System Panel"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
            </div>

            {/* Ratings */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-primary">📏 Ratings</h4>
              <ul className="text-muted">
                <li><strong>Voltage:</strong> 415V, 3-phase, 50Hz</li>
                <li><strong>Current Rating:</strong> Up to 6300A</li>
                <li><strong>Generator Sets:</strong> 2 to 8 (expandable)</li>
                <li><strong>Control Modes:</strong> Auto, Manual, Grid-Sync</li>
              </ul>
            </div>

            {/* IEC Standards */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-info">📘 IEC Standards</h4>
              <ul className="text-muted">
                <li><strong>IEC 61439-1 & 2</strong> – Low-voltage switchgear assemblies</li>
              </ul>
            </div>

            {/* Key Features */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-success">✨ Key Features</h4>
              <ul className="text-muted">
                <li>Automatic synchronization of multiple gensets</li>
                <li>Load sharing, load shedding, and power management</li>
                <li>Microprocessor-based controller with touch HMI</li>
                <li>Grid-parallel operation capability</li>
                <li>Real-time monitoring and protection features</li>
                <li>SCADA/BMS integration</li>
                <li>Customizable logic for complex sequencing</li>
                <li>Fail-safe interlocks for system safety</li>
              </ul>
            </div>

            {/* CTA */}
            <div
              className="p-4 bg-white border-start border-4 border-primary rounded shadow-sm"
              data-aos="fade-up"
            >
              <h5 className="text-dark fw-semibold">Need Synchronization Solutions?</h5>
              <p className="mb-2 text-muted">
                Contact us to discuss your project requirements or request a custom-built synchronizing panel.
              </p>
              <a
                href="/contact"
                className="btn"
                style={{
                  backgroundColor: '#08717A',
                  color: '#fff',
                  border: 'none',
                }}
              >
                Contact Us
              </a>
            </div>
          </div>

          {/* Sidebar */}
          <ElectricalSidebar />
        </div>
      </div>
    </section>
  );
}

export default SynchronizingPanel;
